import { BOOL_FIELD } from '../type_name'
import { VSpacer } from 'vuetify/lib'
export default {
    name: BOOL_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        }
    },
    render(h) {
        const { label, key, val_arr = ['是', '否'], valueRender } = this.field
        let value = '-'

        if (valueRender) {
            value = valueRender({field:this.field, value:this.value})
        } else {
            if (this.value[key] === true) {
                value = val_arr[0]
            } else if (this.value[key] === false) {
                value = val_arr[1]
            }
        } 
        console.log('value', value)
        return h('div', {
            style: {
                display: 'flex',
                width: '100%'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            h('span', {}, value)
        ])
    }
}